
import { UseFormRegister, UseFormWatch } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ProductFormData } from "@/utils/productHelpers";
import InventoryManager from "./InventoryManager";
import ProductBundleManager from "./ProductBundleManager";

interface InventoryTabProps {
  register: UseFormRegister<ProductFormData>;
  watch: UseFormWatch<ProductFormData>;
  product?: any;
}

const InventoryTab = ({ register, watch, product }: InventoryTabProps) => {
  const currentStock = watch("stock_quantity") || 0;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card className="admin-card border-admin-border">
          <CardHeader>
            <CardTitle className="text-admin-foreground">Basic Stock Information</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label htmlFor="stock_quantity">Stock Quantity</Label>
              <Input
                id="stock_quantity"
                type="number"
                {...register("stock_quantity", { required: "Stock quantity is required", min: 0 })}
                className="mt-1"
              />
            </div>

            <div>
              <Label htmlFor="weight">Weight (kg)</Label>
              <Input
                id="weight"
                type="number"
                step="0.01"
                {...register("weight", { min: 0 })}
                className="mt-1"
                placeholder="0.00"
              />
            </div>
          </CardContent>
        </Card>

        <Card className="admin-card border-admin-border">
          <CardHeader>
            <CardTitle className="text-admin-foreground">Stock Status</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div>
                <Label className="text-sm font-medium">Current Stock Level</Label>
                <p className="text-2xl font-bold">{currentStock}</p>
                {currentStock <= 10 && currentStock > 0 && (
                  <p className="text-yellow-600 text-sm">Low stock warning</p>
                )}
                {currentStock === 0 && (
                  <p className="text-red-600 text-sm">Out of stock</p>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Advanced Inventory Management - Only show for existing products */}
      {product?.id && (
        <div className="space-y-6">
          <InventoryManager 
            productId={product.id} 
            currentStock={currentStock} 
          />
          
          <ProductBundleManager 
            productId={product.id}
            onBundlesChange={() => {
              // Could trigger a refetch of product data if needed
            }}
          />
        </div>
      )}
    </div>
  );
};

export default InventoryTab;
